<template>
  <div>
    <base-wallet-values>
      <template #updatedat v-if="walletUpdatedAt">
        {{ walletUpdatedAt | updatedAt }}
      </template>
      <template #label-first>
        <div
          class="tooltip is-inline-flex is-tooltip-multiline"
          data-tooltip="Este valor será liberado em até 3 dia utéis após o recebido"
        >
          <i class="icon" height="16px">
            <base-icon name="painel/time-icon" />
          </i>
          Aguardando liberação
        </div>
      </template>
      <template #money-first>
        <base-reload
          :isReload="false"
          label=""
          v-if="amountToReceive.loading"
        />
        <base-reload
          class="has-text-white"
          v-else-if="amountToReceive.pending"
        />
        <a
          :href="urlGifts"
          title="Ver presentes"
          class="is-block has-text-white"
          v-else
        >
          {{ amountToReceive | currency }}
        </a>
      </template>
      <template #button-first>
        <a
          :href="urlGifts"
          title="Ver presentes"
          target="_blank"
          class="c-wallet-values__button button c-wallet-values__button--wallet-without-shopping"
        >
          <span>Ver presentes</span>
          <i class="icon">
            <base-icon name="painel/arrow-right-icon" width="18" height="18" />
          </i>
        </a>
      </template>
      <template #label-second>
        <i class="icon" style="margin-left: -24px"></i>
        Disponível para uso
      </template>
      <template #money-second>
        <base-reload :isReload="false" label="" v-if="walletSummary.loading" />
        <base-reload class="has-text-white" v-else-if="walletSummary.pending" />
        <router-link
          :to="{ name: 'carteira-extrato' }"
          title="Ver extrato"
          class="is-block has-text-white"
          v-else
        >
          {{ walletSummary.balance | currency }}
        </router-link>
      </template>
      <template #button-second>
        <router-link
          :to="{ name: 'carteira-extrato' }"
          title="Ver extrato"
          class="c-wallet-values__button button c-wallet-values__button--wallet-without-shopping"
        >
          <span>Ver extrato</span>
          <i class="icon">
            <base-icon name="painel/arrow-right-icon" width="18" height="18" />
          </i>
        </router-link>
      </template>
      <template #footer>
        <button
          @click="requestWithdraw"
          :disabled="walletSummary.balance <= 0"
          type="button"
          class="c-wallet-values__button-paypal button is-paypal is-big"
        >
          <base-icon width="2em" height="2em" name="paypal-white-color" />
          Transferir
        </button>
      </template>
    </base-wallet-values>
    <TheModalAccountIsPending ref="modalAccountIsPending" />
    <BaseModalError
      ref="modalErrorBalance"
      title="Erro ao carregar saldo"
      icon="paypal-with-error"
      :message="`<strong>Infelizmente não será possível solicitar<br>a transferência neste momento!</strong>`"
    />
  </div>
</template>

<script>
import BaseWalletValues from '@/components/Wallet/BaseWalletValues.vue'
import TheModalAccountIsPending from '@/components/Wallet/TheModalAccountIsPending.vue'
import BaseModalError from '@/components/BaseModalError.vue'

import { format } from 'date-fns'

const API_LEGACY_URL = process.env.VUE_APP_API_LEGACY_URL

export default {
  components: {
    BaseWalletValues,
    TheModalAccountIsPending,
    BaseModalError,
  },

  filters: {
    updatedAt(date) {
      return format(new Date(date), '[Atualizado em] DD/MM/YYYY [às] HH:mm')
    },
  },

  computed: {
    walletSummary() {
      return this.$store.state.wallet.walletSummary
    },
    amountToReceive() {
      return this.$store.state.wallet.amountToReceive
    },
    walletUpdatedAt() {
      return this.$store.state.wallet.walletUpdatedAt
    },
    urlGifts() {
      const logonToken = this.$store.state.app.logonToken
      if (logonToken)
        return `${API_LEGACY_URL}/${logonToken.token_payload.wed_id}#/admin/presentes/ganhados`
      return '#'
    },
  },

  methods: {
    requestWithdraw() {
      if (this.walletSummary.pending) {
        this.$refs.modalErrorBalance.open()
        return
      } else if (this.walletSummary.balance <= 0) return
      else if (this.walletSummary.wallet.pending)
        this.$refs.modalAccountIsPending.open()
      else this.$router.push({ name: 'carteira' })
    },
  },
}
</script>

<style lang="scss">
.c-wallet-values {
  &__button {
    &--wallet-without-shopping {
      background-color: transparent;
      border-color: #fff;
      color: #fff;

      @media (max-width: $mobile) {
        width: auto !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
        right: 34% !important;
        top: 72% !important;
      }

      .icon {
        .icon-svg {
          fill: #fff;
        }
      }
    }

    &--wallet-without-shopping:hover,
    &--wallet-without-shopping:active,
    &--wallet-without-shopping:focus {
      color: $white !important;

      @media (min-width: $tablet) {
        color: $support !important;
        background-color: $white !important;
      }
    }
  }

  &__button-paypal {
    display: inline-flex;
    align-items: center;
  }
}

.tooltip {
  align-items: center;
}
</style>
